export const environment = {
  production: false,
  graphqlURL: 'https://talent-hub-dev-server-6uadh2aniq-oa.a.run.app/graphql',
  aiServer: 'https://talent-hub-flask-server-dev-6uadh2aniq-oa.a.run.app/api',
};
